import { useContext, useEffect } from 'react'
import { Button, Dialog, Link, Text } from '@/ui'
import { PlaidLinkContext } from './LinkContext'

export const PlaidErrorDialog = () => {
  const { plaidError, clearPlaidError } = useContext(PlaidLinkContext)

  useEffect(() => {
    return () => {
      clearPlaidError()
    }
  }, [clearPlaidError])

  return (
    <Dialog open={Boolean(plaidError)} onClose={clearPlaidError}>
      <Dialog.Content>
        <Dialog.Title>Plaid Connection Error</Dialog.Title>

        <Text>{plaidError?.message}</Text>

        {plaidError?.errorCode === 'ID_NOT_FOUND' && (
          <Text>
            Check out{' '}
            <Link href="https://plaid.com/trouble-connecting/" newPage>
              some possible reasons
            </Link>{' '}
            for why this is happening and try adding the connection again.
          </Text>
        )}

        {plaidError?.errorCode === 'INTERNAL_SERVER_ERROR' && (
          <Text>
            In the meantime, check out{' '}
            <Link href="https://plaid.com/trouble-connecting/" newPage>
              some possible reasons
            </Link>{' '}
            for why this is happening.
          </Text>
        )}

        <Text>
          If this error persists, reach out to us via{' '}
          <Link href="/conversations">Conversations</Link>.
        </Text>

        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button
              variant="secondary"
              style={{ marginRight: 8 }}
              onClick={clearPlaidError}
            >
              Close
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
